import { useCallback, useEffect, useState } from 'react';

// Shamelessly stolen from:
// https://dev.to/eraywebdev/how-to-check-if-a-tab-is-active-in-react-1o0l
const useIsTabActive = () => {
  const [isTabVisible, setIsTabVisible] = useState(true);

  const handleVisibilityChange = useCallback(() => {
    setIsTabVisible(document.visibilityState === 'visible');
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isTabVisible;
};

export default useIsTabActive;
